import React, { Component } from 'react';
import { connect } from 'react-redux'
import { dzeramaUdensSatecesBaseinsActions, updateUrbumsAizsargjosla } from '../../actions/dzeramaUdensSatecesBaseiniActions';
import Loading from '../Loading';
import Link from 'redux-first-router-link';
import BootstrapTable from 'react-bootstrap-table-next';
import cellEditFactory, { Type } from 'react-bootstrap-table2-editor';
import { Button } from 'reactstrap';
import NavGeometrijaBridinajums from './NavGeometrijaBridinajums';
import { getFormatterForKodif } from '../grid/ColumnHelpers';


class BaseinsAizsargjoslas extends Component {

    onBeforeSaveCell = (oldValue, newValue, row, column) => {
        if (oldValue !== newValue) {
            this.props.updateUrbumsAizsargjosla(row.urbumi_id, column.dataField, newValue)
        }
    }

    handleSave = () => {
        const { selectedItem } = this.props.dzeramaUdensSatecesBaseins
        if (selectedItem) {
            this.props.saveAct(selectedItem)
        }
    }

    getColumns = () => {
        const { kodif } = this.props
        return [
            {
                dataField: 'urbumi_id',
                text: 'Ūdens ieguves vietas DB Nr.',
                formatter: (cell) => (
                    <Link
                        to={{
                            type: 'loc_urbums',
                            payload: { id: cell }
                        }}
                    >
                        {cell}
                    </Link>
                ),
                editable: false,
                headerStyle: { width: 150 }
            }, {
                dataField: 'stingra_aizsargjosla',
                text: 'Stingra režīma aizsargjosla',
                headerStyle: { width: 180 }
            }, {
                dataField: 'bakter_aizsargjosla',
                text: 'Bakterioloģiskā aizsargjosla',
                headerStyle: { width: 200 }
            }, {
                dataField: 'kim_aizsargjosla',
                text: 'Ķīmiskā aizsargjosla',
                headerStyle: { width: 180 }
            }, {
                dataField: 'pasakumi',
                text: 'Žogs ap urbumu',
                formatter: getFormatterForKodif(kodif.zogsApUrbumu),
                editor: {
                    type: Type.SELECT,
                    options: Object.keys(kodif.zogsApUrbumu).map(k => ({ value: k, label: kodif.zogsApUrbumu[k].nos }))
                }
            }, {
                dataField: 'piezimes',
                text: 'Piezīmes'
            }
        ]
    }

    render() {

        const { dzeramaUdensSatecesBaseins, hasGeometry, user } = this.props

        const { selectedItem, editable, submiting } = dzeramaUdensSatecesBaseins

        if (!selectedItem) {
            return (<Loading />)
        }

        if (!hasGeometry) {
            return <NavGeometrijaBridinajums title="Aizsargjoslas" />;
        }

        const udesIeguvesVietas = selectedItem.udens_ieguves_vietas || [];
        const isArhivets = !!selectedItem.ir_arhivets
        const canEdit = !isArhivets && user && user.tiesibas && user.tiesibas.includes('SATECES_BASEINI_LABOT')

        return (
            <div style={{ display: 'flex', flexDirection: 'column', height: 'calc(100vh - 250px)' }}>
                {canEdit && <div style={{ marginBottom: '10px' }}>
                    {!editable && (
                        <Button color="primary" onClick={this.props.startEditAct}>
                            <i className="fa fa-pencil"></i>&nbsp;&nbsp;Labot
                        </Button>
                    )}
                    {editable && (
                        <>
                            <Button color="success" onClick={this.handleSave} disabled={submiting} style={{ marginRight: '5px' }}>
                                <i className="fa fa-save"></i>&nbsp;&nbsp;Saglabāt
                            </Button>
                            <Button color="secondary" onClick={this.props.stopEditAct} disabled={submiting}>
                                <i className="fa fa-times"></i>&nbsp;&nbsp;Atcelt
                            </Button>
                        </>
                    )}
                </div>}
                <div className="editable-grid-info">
                    { editable ? <><i className="fa fa-pencil"></i>&nbsp;&nbsp;Lai rediģētu tabulas vērtības, jāveic peles dubultklikšķis uz attiecīgās šūnas tabulā.</> : '' }
                </div>
                <BootstrapTable
                    bootstrap4
                    striped
                    hover
                    keyField="urbumi_id"
                    data={udesIeguvesVietas}
                    columns={this.getColumns()}
                    cellEdit={cellEditFactory({
                        mode: 'dbclick',
                        blurToSave: true,
                        beforeSaveCell: this.onBeforeSaveCell,
                        nonEditableRows: () => editable ? [] : udesIeguvesVietas.map(u => u.urbumi_id)
                    })}
                    selectRow={{
                        mode: 'radio',
                        clickToSelect: true,
                        clickToEdit: true,
                        hideSelectColumn: true,
                        classes: 'selection-row'
                    }}
                    noDataIndication={() => 'Nav datu'}
                />
            </div>
        )
    }
}

const mapStateToProps = ({ dzeramaUdensSatecesBaseins, kodif, user }) => ({ dzeramaUdensSatecesBaseins, kodif, user })

const DzeramaUdensSatecesBaseinsAizsargjoslas = connect(mapStateToProps, { ...dzeramaUdensSatecesBaseinsActions, updateUrbumsAizsargjosla })(BaseinsAizsargjoslas)
export default DzeramaUdensSatecesBaseinsAizsargjoslas
